/* RESPONSIBLE TEAM: team-proactive-support */
import EditorConfig from 'embercom/objects/content-editor/content-editor-configuration';
import generateViewModeConfig from 'embercom/objects/content-editor/configuration-generators/post/view-mode-generator';
import generateEditModeConfig from 'embercom/objects/content-editor/configuration-generators/post/edit-mode-generator';
import generateNotificationMessages from 'embercom/objects/content-editor/configuration-generators/standard-notification-messages-generator';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import generateSeriesModeConfig from 'embercom/objects/series/ruleset-editor/post/editor-configuration-generator';

export default function generateEditorConfig(options) {
  options.objectType = objectTypes.post;
  return EditorConfig.create({
    viewMode: generateViewModeConfig(options),
    editMode: generateEditModeConfig(options),
    notificationMessages: generateNotificationMessages(options),
    seriesMode: generateSeriesModeConfig(options),
    requiredFeature: 'post_in-app_message',
  });
}
